import React, { useEffect, useState } from "react";
import { FaAngleDoubleDown, FaAngleDoubleUp } from "react-icons/fa";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import "swiper/swiper-bundle.min.css";
import { Swiper, SwiperSlide } from "swiper/react";

import './PendingOrderAccordion.css';
import ReceiptModal from "./ReceiptModal";
import { Navigation } from "swiper";
import { Progress } from "antd";
import ProgressBar from "./ProgressBar";
import axios from "axios";
import jwtDecode from "jwt-decode";

const PendingOrderAccordion = () => {
  const [pendingOrders, setPendingOrders] = useState([]);

  const fetchPendingOrders = async (userId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_SECRET}/api/Order/GetPendingOrderDataByUserIdV2?userId=${userId}`);
      const data = await response.data;
      setPendingOrders(data);
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    const token = localStorage.getItem("gotasteClienttoken");

    if (token) {
      try {
        const { UserId: userId } = jwtDecode(token);
        if (userId) {
          fetchPendingOrders(userId);
        }
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);


  const [showAll, setShowAll] = useState(false);

  const handleToggle = () => {
    setShowAll((prev) => !prev);
  };

  const [open, setOpen] = useState({ isOpen: false, timeLine: [] });

  const handleOpen = (data) => {
    setOpen({ isOpen: true, timeLine: data });
  }

  const handleClose = () => {
    setOpen({ isOpen: false, timeLine: [] });
  }

  console.log('pendingOrders', pendingOrders)


  return (
    <>
      <h2 className="text-center">Order Details</h2>
      <p className="text-center text-muted">{pendingOrders?.length} Orders pending</p>
      <div className="pending-container mt-4">

        {pendingOrders.map((order, index) => (
          <Accordion key={index} defaultExpanded={index === 0}>
            <AccordionSummary className="shadow">
              <div className="d-flex justify-content-between align-items-center w-100 pending-order-accordion-header">
                <div className="mb-3">
                  <strong>Order ID:</strong> {order.orderId} <br />
                  <strong>{order.restaurantName}</strong>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <button className="receipt-button" onClick={() => handleOpen(order.timeLine)}>Receipt</button>
                  <button className="ready-button">{order?.orderStatus}</button>
                  <p className="text-color mb-0 price-tag">£{order.total}</p>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails className="bg-light mt-2">
              <div className="order-images mb-3">
                <Swiper
                  spaceBetween={0}
                  slidesPerView={1}
                  onSlideChange={() => console.log('slide change')}
                  onSwiper={(swiper) => console.log(swiper)}
                  navigation={true}
                  breakpoints={{
                    437: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    545: {
                      spaceBetween: 12,
                      slidesPerView: 2.4,
                    },
                    768: {
                      slidesPerView: 3,
                    }
                  }}
                >
                  {
                    order?.images?.map((image, idx)=> (
                      <SwiperSlide key={idx} className="d-flex justify-content-center">
                        <div className="pending-slider-img-container">
                          <img src={image.url} alt={`${order.orderId}-${idx}`} />
                        </div>
                      </SwiperSlide>
                    ))
                  }
                </Swiper>
                {/* <Swiper
              spaceBetween={10} // Adjusted space between slides to reduce gap
              slidesPerView={Math.min(order.images.length, 3)} // Dynamically handle slides per view
              navigation={order.images.length > 2} // Enable navigation only if more than 2 images
              modules={[Navigation]}
              loop={order.images.length > 2} // Enable loop only if more than 2 images
              style={{ maxWidth: order.images.length === 2 ? '500px' : '750px', margin: "0 auto" }} // Center align and constrain width
            >
              {order.images.map((image, idx) => (
                <SwiperSlide
                  key={idx}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center", // Center align the images
                  }}
                >
                  <div
                    className="image-container"
                    style={{
                      width: "250px", // Fixed width
                      height: "250px", // Fixed height
                      overflow: "hidden",
                      borderRadius: "8px",
                    }}
                  >
                    <img
                      src={image.url}
                      alt={`Order ${idx}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // Ensures consistent image display
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper> */}
              </div>

              <ProgressBar order={order} />

              <p className="text-center text-secondary mb-0 fw-bold">
                Your order is {order.orderStatus}.
              </p>
              <p className="text-center text-secondary">Please Wait.</p>

              <div className="row">
                <div className="col-md-7">
                  {order.foodItems?.slice(0, showAll ? order.foodItems.length : 2).map((item, idx) => (
                    <div key={idx} className="order-item mb-3 p-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="mb-0 fw-bold">
                          {idx + 1}) {item.foodItemName} <span className="fw-normal">x{item.foodItemQuantity}</span>
                          <span className="ms-2 text-muted">£{item.basePrice}</span>
                        </h6>
                        <div className="d-flex align-items-center">
                          <span className="status-badge px-3 py-1 me-3">{item.foodStatus}</span>
                          <span className="fw-bold">£{item.totalFoodItemPrice}</span>
                        </div>
                      </div>
                      {item?.addOns?.map(
                        (addOn) =>
                          addOn?.addOnQuantity > 0 && (
                            <div key={addOn.addOnId} style={{ marginLeft: "18px" }}>
                              {/* Display AddOn */}
                              <h6>
                                {addOn.addOnName} x{addOn.addOnQuantity}
                                <span> £{addOn.addOnBasePrice}</span>
                              </h6>
                              {/* Display Options */}
                              {addOn?.options?.map(
                                (option) =>
                                  option?.optionQuantity > 0 && (
                                    <div
                                      key={option.optionId}
                                      style={{ marginLeft: "1rem" }}
                                    >
                                      <h6>
                                        {option.optionName} x{option.optionQuantity}
                                        <span> £{option.optionBasePrice}</span>
                                      </h6>
                                      {/* Display SubOptions */}
                                      {option?.subOptions?.map((subOption) => (
                                        <div
                                          key={subOption.subOptionId}
                                          style={{ marginLeft: "2rem" }}
                                        >
                                          <span>
                                            {subOption.subOptionName} x1
                                            <span> £{subOption.subOptionBasePrice}</span>
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  )
                              )}
                            </div>
                          )
                      )}
                    </div>
                  ))}
                </div>
                <div className="col-md-5">
                  <div className="payment-breakdown p-3 shadow-sm rounded" >
                    <h6 className="mb-3">Payment Break Downs</h6>
                    <ul className="list-unstyled" style={{ padding: 0, margin: 0, fontSize: "14px", color: "#555" }}>
                      <li className="d-flex justify-content-between mb-2">
                        <span>Sub Total</span> <span>£{order?.subTotal}</span>
                      </li>
                      <li className="d-flex justify-content-between mb-2">
                        <span>Total VAT Inc. SD</span> <span>£{order?.totalVatIncSd}</span>
                      </li>
                      <li className="d-flex justify-content-between mb-2">
                        <span>Total Service Charge Exc. VAT</span> <span>£{order?.totalServiceChargeExcVat}</span>
                      </li>
                      <li className="d-flex justify-content-between mb-2">
                        <span>Total Tips</span> <span>£{order?.totalTips}</span>
                      </li>
                      <li className="d-flex justify-content-between mb-2">
                        <span>Delivery Fee Inc. VAT (20%)</span> <span>£{order?.deliveryFeeIncVat}</span>
                      </li>
                      <li className="d-flex justify-content-between mb-2">
                        <span>Credit</span> <span>£{order?.credit}</span>
                      </li>
                    </ul>
                    <hr />
                    <div>
                      <h6 className="d-flex justify-content-between">
                        <div className="d-flex flex-column">
                          <h6 className="bold-text">Total Price</h6>
                          <span className="fs-6">(VAT Inc.)</span>
                        </div>
                        <h6 className="bold-text">£{order.total}</h6>
                      </h6>
                    </div>
                    {/* <h6 className="d-flex justify-content-between" style={{ fontWeight: 700, color: "#333" }}>
                    div
                    <span>Total Price (VAT Inc.)</span>
                     <span>£{order.total}</span>
                  </h6> */}
                  </div>
                </div>
              </div>

              {order.foodItems?.length > 2 && (
                <div className="text-center">
                  <button className="see-more-btn" onClick={handleToggle}>
                    {showAll ? "See Less" : "See More"}
                    {showAll ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
                  </button>
                </div>
              )}
            </AccordionDetails>
          </Accordion>
        ))}

        <ReceiptModal open={open?.isOpen} handleClose={handleClose} timeLineData={open.timeLine} />
      </div>
    </>
  );
};

export default PendingOrderAccordion;
